import buildHouseConnectionOnlyFields from './house-connection-only-data';
import buildHouseConnectionAndInfrastructureFields from './house-connection-and-infrastructure-data';
import useOrderStore from '../store/order';

export default function preparePassiveOrderFields(): string {
  const { orderRequestData } = useOrderStore();

  const fields = orderRequestData!.isMphOrder
    ? buildHouseConnectionAndInfrastructureFields()
    : buildHouseConnectionOnlyFields();

  return JSON.stringify(fields);
}

// TBD check: administrator.differentContactPerson
